import { Trans, useTranslation } from "react-i18next";
import {
    AddressInfoSection, AddressSectionWrapper, AddressText, StyledLink
} from "./ContactsAddressComponents";
import { contactsEmail, contactsPhone, displayedContactsPhone } from "../../../../constants/contacts";
import YandexMaps from "../../../common/YandexMaps/YandexMaps/YandexMaps";

const AddressSection = () => {
    const { t } = useTranslation("translation", {keyPrefix: "contacts"});

    return (
        <AddressSectionWrapper>
            <AddressInfoSection>
                <StyledLink href={`tel:${contactsPhone}`}>
                    {displayedContactsPhone}
                </StyledLink>
                <StyledLink href={`mailto:${contactsEmail}`}>
                    {contactsEmail}
                </StyledLink>
                <AddressText>
                    <Trans
                        t={t}
                        i18nKey="address"
                        components={{ br: <br/> }}
                    />
                </AddressText>
            </AddressInfoSection>
            <YandexMaps />
        </AddressSectionWrapper>
    )
}

export default AddressSection;